import type { PartnerResponseDto } from "Infrastructure/Api/Api";
import { PartnerAddressFormWidget } from "Partner/Widgets/PartnerAddressFormWidget";
import { PartnerBankAccountFormWidget } from "Partner/Widgets/PartnerBankAccountFormWidget";
import { PartnerBillingProfileFormWidget } from "Partner/Widgets/PartnerBillingProfileFormWidget";
import { PartnerGeneralFormWidget } from "Partner/Widgets/PartnerGeneralFormWidget";
import { PRIMARY_ADDRESS } from "Shared/consts";
import { Grid2 } from "@mui/material";

export type PartnerEditTabProps = {
	partner: PartnerResponseDto;
};

export function PartnerEditTab({ partner }: PartnerEditTabProps) {
	const serviceAreas =
		(
			partner as PartnerResponseDto & {
				serviceAreas?: Array<{
					marketRegionId: number;
					originAddress: string;
					isPrimary: boolean;
					isActive: boolean;
				}>;
			}
		).serviceAreas ?? [];
	const primaryAddress = partner.address?.find(
		(item) => item.type === PRIMARY_ADDRESS,
	);

	return (
		<Grid2 container spacing={2}>
			<Grid2 container spacing={2} size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
				<Grid2 size={{ xs: 12 }}>
					<PartnerGeneralFormWidget
						data={partner.partner}
						partnerId={partner.partner.id}
						serviceAreas={serviceAreas}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12 }}>
					<PartnerBillingProfileFormWidget
						data={partner?.billingProfile ?? undefined}
						partnerId={partner.partner.id}
					/>
				</Grid2>
			</Grid2>

			<Grid2
				container
				spacing={2}
				size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
				direction={{ xs: "row", md: "column" }}
			>
				<Grid2 size={{ xs: 12 }}>
					{primaryAddress && (
						<PartnerAddressFormWidget
							data={primaryAddress}
							partnerId={partner.partner.id}
						/>
					)}
				</Grid2>
				<Grid2 size={{ xs: 12 }}>
					<PartnerBankAccountFormWidget
						data={partner?.bankAccount ?? undefined}
						partnerId={partner.partner.id}
					/>
				</Grid2>
			</Grid2>
		</Grid2>
	);
}
